import { render, staticRenderFns } from "./AccomItem.vue?vue&type=template&id=40232d51&scoped=true&"
import script from "./AccomItem.vue?vue&type=script&lang=js&"
export * from "./AccomItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40232d51",
  null
  
)

export default component.exports